import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Profile({ onLogout }: { onLogout: () => void }) {
  const [installPrompt, setInstallPrompt] = React.useState<any>(null);
  const [installed, setInstalled] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      setInstallPrompt(e);
    });
    window.addEventListener('appinstalled', () => setInstalled(true));
    // Detectar si ya está instalada
    if (window.matchMedia('(display-mode: standalone)').matches) setInstalled(true);
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const { outcome } = await installPrompt.userChoice;
    if (outcome === 'accepted') setInstalled(true);
    setInstallPrompt(null);
  };
  const [profile, setProfile] = useState<any>(null);
  const [form, setForm] = useState({ name: '', phone: '', current_password: '', new_password: '', new_password2: '' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [subscription, setSubscription] = useState<any>(null);
  const tenant = JSON.parse(localStorage.getItem('customer_tenant') || '{}');
  const color = tenant.color || '#7C3AED';

  useEffect(() => {
    api.get('/api/customer/me').then(({ data }) => {
      setProfile(data.user);
      setForm(f => ({ ...f, name: data.user.name || '', phone: data.user.phone || '' }));
    }).catch(console.error);

    api.get('/api/customer/subscription/status').then(({ data }) => {
      setSubscription(data.active_subscription);
    }).catch(console.error);
  }, []);

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.new_password && form.new_password !== form.new_password2) {
      return setMsg('❌ Las contraseñas no coinciden');
    }
    setSaving(true);
    try {
      const payload: any = {};
      if (form.name) payload.name = form.name;
      if (form.phone) payload.phone = form.phone;
      if (form.new_password) { payload.current_password = form.current_password; payload.new_password = form.new_password; }
      await api.patch('/api/customer/me', payload);
      setMsg('✅ Perfil actualizado');
      setForm(f => ({ ...f, current_password: '', new_password: '', new_password2: '' }));
    } catch (err: any) {
      setMsg('❌ ' + (err.response?.data?.error || 'Error'));
    } finally { setSaving(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f1a', color: '#fff', fontFamily: 'sans-serif', padding: '1.5rem' }}>
      {/* Banner instalación PWA */}
      {!installed && installPrompt && (
        <div style={{ background:'linear-gradient(135deg, #7C3AED, #4f46e5)', borderRadius:'12px', padding:'1.25rem', marginBottom:'1rem', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontWeight:700, fontSize:'0.95rem' }}>📱 Instalar app</div>
            <div style={{ color:'#c4b5fd', fontSize:'0.82rem' }}>Accede más rápido desde tu pantalla de inicio</div>
          </div>
          <button onClick={handleInstall} style={{ background:'#fff', border:'none', borderRadius:'8px', color:'#7C3AED', padding:'0.5rem 1rem', fontWeight:700, cursor:'pointer', flexShrink:0 }}>
            Instalar
          </button>
        </div>
      )}
      {installed && (
        <div style={{ background:'#064e3b', borderRadius:'12px', padding:'0.75rem 1rem', marginBottom:'1rem', fontSize:'0.85rem', color:'#6ee7b7' }}>
          ✅ App instalada en tu dispositivo
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2 style={{ margin: 0 }}>👤 Mi perfil</h2>
        <button onClick={onLogout} style={{ padding: '0.4rem 0.8rem', background: 'transparent', border: '1px solid #444', borderRadius: '8px', color: '#888', cursor: 'pointer' }}>Salir</button>
      </div>

      {/* Suscripción */}
      <div style={{ background: subscription ? '#064e3b' : '#1a1a2e', borderRadius: '12px', padding: '1.25rem', marginBottom: '1.5rem', border: `1px solid ${subscription ? '#10b981' : '#2a2a3e'}` }}>
        <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>
          {subscription ? '✅ Suscripción activa' : '⚠️ Sin suscripción activa'}
        </div>
        {subscription ? (
          <div style={{ color: '#6ee7b7', fontSize: '0.85rem' }}>
            Plan {subscription.plan_type} · Vence: {new Date(subscription.ends_at).toLocaleDateString('es-CO')}
          </div>
        ) : (
          <div style={{ color: '#888', fontSize: '0.85rem' }}>Suscríbete para acceder al catálogo completo</div>
        )}
      </div>

      {/* Datos */}
      <div style={{ background: '#1a1a2e', borderRadius: '12px', padding: '1.5rem', border: '1px solid #2a2a3e' }}>
        <form onSubmit={handleSave}>
          <div style={{ color: '#888', fontSize: '0.78rem', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Datos personales</div>
          <input style={inp} placeholder="Nombre" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
          <input style={inp} placeholder="Teléfono" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
          {profile?.email && <div style={{ color: '#555', fontSize: '0.82rem', marginBottom: '0.75rem', padding: '0.5rem 0' }}>📧 {profile.email}</div>}

          <div style={{ color: '#888', fontSize: '0.78rem', margin: '1rem 0 0.75rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Cambiar contraseña</div>
          <input style={inp} type="password" placeholder="Contraseña actual" value={form.current_password} onChange={e => setForm(f => ({ ...f, current_password: e.target.value }))} />
          <input style={inp} type="password" placeholder="Nueva contraseña" value={form.new_password} onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))} />
          <input style={inp} type="password" placeholder="Confirmar nueva contraseña" value={form.new_password2} onChange={e => setForm(f => ({ ...f, new_password2: e.target.value }))} />

          {msg && <p style={{ color: msg.startsWith('✅') ? '#10b981' : '#ef4444', fontSize: '0.9rem', margin: '0 0 0.75rem' }}>{msg}</p>}
          <button type="submit" disabled={saving} style={{ width: '100%', padding: '0.75rem', background: color, border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 600, cursor: 'pointer' }}>
            {saving ? 'Guardando...' : '💾 Guardar cambios'}
          </button>
        </form>
      </div>
    </div>
  );
}

const inp: React.CSSProperties = { width: '100%', padding: '0.75rem 1rem', marginBottom: '0.75rem', background: '#0f0f1a', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '0.95rem', boxSizing: 'border-box' };
